module.exports = __webpack_public_path__ + "img/kostira.a00343d2.jpeg";